import Box from "@mui/material/Box";
import { observer } from "mobx-react-lite";
import React from "react";
import MultiSelector, { MultiSelectorOptionInterface } from "../../../../components/selectors/MultiSelector";
import i18nStore from "../../../../i18n/store";
import filterStore from "../filters/filtersStore";
import BaseResultTable, { BaseCalculationsTablePropsProps } from "./BaseResultTable";
import { useMuiCalculationsNodesColDefs } from "./useMuiCalculationsNodesColDefs";
import { VectorTypeEnum } from "../../enums";


interface ResultNodesTableProps extends BaseCalculationsTablePropsProps {}
const ResultNodesTable = observer((props: ResultNodesTableProps) => {
    const translations = i18nStore.getTranslations;

    const columnDefs = useMuiCalculationsNodesColDefs();

    return (
        <BaseResultTable
            table="nodes"
            colDefs={columnDefs}
            rows={props.rows}
            loading={props.loading}
            extraToolbar={
                <Box>
                    <MultiSelector
                        values={filterStore.getNodeValueTypes}
                        setValues={(vals) => filterStore.setNodeValueTypes(vals)}
                        options={[
                            {tooltipText: translations.vectorTypeEnum.phase, label: "a", value: VectorTypeEnum.Phase.name},
                            {tooltipText: translations.vectorTypeEnum.sequencePhase, label: "1", value: VectorTypeEnum.Sequence.name},
                            {tooltipText: translations.vectorTypeEnum.linear, label: "ab", value: VectorTypeEnum.Linear.name},
                        ] as MultiSelectorOptionInterface[]}
                    />
                </Box>
            }
        />
    );
});

export default ResultNodesTable;
